module.exports = __webpack_public_path__ + "img/vpc.009ed8d.png";